import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';

const GA4_ID = 'G-MPK8XXQJ4M';

function RouteTracker() {
    const { pathname, search } = useLocation();
    useEffect(() => {
        if (typeof window.gtag !== 'function') return;
        window.gtag('config', GA4_ID, { page_path: pathname + search });
    }, [pathname, search]);
    return null;
}

/* Each route is a separate chunk — downloaded only when visited */
const HomePage       = lazy(() => import('../client/Home/HomePage'));
const NotFound       = lazy(() => import('../NotFound'));
const HomeIndex      = lazy(() => import('../client/Home/HomeIndex'));
const LoginIndex     = lazy(() => import('../client/Login/LoginIndex'));
const Thingstodo     = lazy(() => import('../client/Home/thingstodo'));
const Blog           = lazy(() => import('../client/Home/blog/blogIndex'));
const About          = lazy(() => import('../client/About/AboutIndex'));
const Hotels         = lazy(() => import('../client/Home/Hotels'));
const HotelPageIndex = lazy(() => import('../client/HotelPages/HotelPageIndex'));
const TourplanIndex  = lazy(() => import('../client/tour/tourplanIndex'));
const Map            = lazy(() => import('../Map'));
const RoomTour       = lazy(() => import('../client/Redirect/RoomTour'));
const TourDetails    = lazy(() => import('../client/tourDetails'));
const Ravangla       = lazy(() => import('../client/Redirect/Ravangla'));

/* Minimal fallback — uses the app shell already visible in HTML */
const PageLoader = () => (
  <div style={{
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#0d1b2a', color: '#c9a84c',
    fontSize: '1.5rem',
  }}>
    🏔️
  </div>
);

function LogoutRoutes() {
  return (
    <BrowserRouter>
      <RouteTracker />
      <Suspense fallback={<PageLoader />}>
        <Switch>
          <Route exact path="/"                       component={HomePage} />
          <Route exact path="/Norbulingka/RoomTour"   component={RoomTour} />
          <Route exact path="/r/ravangla"             component={Ravangla} />
          <Route exact path="/Map"                    component={Map} />
          <Route exact path="/Blog"                   component={Blog} />
          <Route exact path="/blog"                   component={Blog} />
          <Route exact path="/Blog/EN"               component={Blog} />
          <Route exact path="/Blog/BN"               component={Blog} />
          <Route exact path="/Login"                  component={LoginIndex} />
          <Route exact path="/Blog/:language/:id"     component={Thingstodo} />
          <Route exact path="/about/"                 component={About} />
          <Route exact path="/our-hotels"             component={Hotels} />
          <Route exact path="/Album"                  component={HomeIndex} />
          <Route exact path="/tour"                   component={TourplanIndex} />
          <Route exact path="/Hotel/:name"            component={HotelPageIndex} />
          <Route exact path="/:name"                  component={HotelPageIndex} />
          <Route exact path="/tour/:path"             component={TourDetails} />
          <Route                                      component={NotFound} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}

export default LogoutRoutes;
